const SagaStatus = {
  NOT_STARTED: 'NOT_STARTED',
  PENDING: 'PENDING',
  COMPLETE: 'COMPLETE',
};

export default SagaStatus;
